<template>
  <div>
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :rows="rows"
      :loading="disable"
      :columns="columns"
      v-model:pagination="pagination"
      class="q-mt-md my-sticky-dynamic"
      ref="table"
      row-key="name"
      hide-pagination
      dense
      @request="handleRequest"
    >
      <template v-slot:top-right>
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          v-model="filtrar"
          type="text"
          placeholder="Pesquisar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template v-slot:header="props">
        <q-tr :props="props">
          <q-th
            class="text-weight-bolder"
            v-for="col in props.cols"
            :key="col.name"
            :props="props"
          >
            {{ col.label }}
          </q-th>
        </q-tr>
      </template>
      <template #body-cell-name="props">
        <q-td>
          {{ props.row.name }}
        </q-td>
      </template>
      <template #body-cell-email="props">
        <q-td>
          {{ props.row.email }}
        </q-td>
      </template>
      <template #body-cell-refresh="props">
        <q-td>
          <q-btn
            v-if="props"
            round
            color="positive"
            icon="refresh"
            flat
            @click="
              confirmarReativacao(props.row.id),
                (reativarDialog = !reativarDialog)
            "
          />
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
    <dialog-info-design
      v-model="dialogConfirmacao"
      mensagem="Confirma reativação?"
      subMensagem="Tem certeza que deseja reativar o colaborador?"
      :exibir="reativarDialog"
      :showCancelar="true"
      @resultado="reativarConfirmado"
    />
  </div>
</template>

<script>
const columns = [
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
  },
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
  {
    name: "email",
    label: "Email",
    field: "email",
    align: "left",
  },
  {
    name: "cargo",
    label: "Cargo",
    field: "cargo",
    align: "left",
  },
  {
    name: "matricula",
    label: "Matricula",
    field: "sap",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    field: "status",
    align: "left",
  },
  {
    name: "admission_date",
    label: "Data de Admissão",
    field: (row) =>
      row.admission_date?.split(" ")[0].split("-").reverse().join("/"),
    align: "left",
  },
  {
    name: "deleted_at",
    label: "Afastado do sistema em",
    field: (row) =>
      row.deleted_at?.split(" ")[0].split("-").reverse().join("/"),
    align: "left",
  },
  {
    name: "refresh",
    label: "Reativar",
    align: "center",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter, useRoute } from "vue-router";
import { ref, onMounted, computed, watch } from "vue";
import DialogInfoDesign from "../../../../components/DialogInfoDesign.vue";
export default {
  components: { DialogInfoDesign },
  emits: ["update:total"],
  setup(props, { emit }) {
    const disable = ref(true);
    const rows = ref([]);
    const store = useStore();
    const quasar = useQuasar();
    const unidade = ref("");
    const router = useRouter();
    const route = useRoute();
    const filtrar = ref("");
    const table = ref("");
    const dialogConfirmacao = ref(false);
    const usuarioSelecionado = ref(null);
    const reativarDialog = ref(false);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });

    const getData = async (page = 0, rowsPerPage = 15) => {
      quasar.loading.show();
      disable.value = true;
      try {
        let response = await store.dispatch("user/getUsuariosAfastados", {
          page,
          search: filtrar.value,
          vendor_id: unidade.value.id,
          per_page: rowsPerPage,
        });

        rows.value = response.data.results.data;

        pagination.value.page = response.data.results.current_page;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;
        emit("update:total", response.data.results.total);
        disable.value = false;
        quasar.loading.hide();
        scrollUp();
      } catch (error) {
        quasar.loading.hide();
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const reativar = async (id) => {
      try {
        await store.dispatch("user/reativarUsuario", {
          id,
        });
        quasar.notify({
          message: "Usuario afastado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getData();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o afastar usuario",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
      getData();
    };

    const confirmarReativacao = (id) => {
      usuarioSelecionado.value = id;
      dialogConfirmacao.value = true;
    };

    const reativarConfirmado = async (resultado) => {
      reativarDialog.value = false;
      if (!resultado) return;
      try {
        await store.dispatch("user/reativarUsuario", {
          id: usuarioSelecionado.value,
        });
        quasar.notify({
          message: "Usuário reativado com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white" }],
        });
        getData();
      } catch (error) {
        quasar.notify({
          message: "Erro ao reativar usuário",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
      } finally {
        dialogConfirmacao.value = false;
        usuarioSelecionado.value = null;
      }
    };

    const scrollUp = () => {
      table.value.scrollTo(0);
    };

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
      getData();
    };

    onMounted(getUnidade);

    watch(
      () => filtrar.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        router.push({
          path: route.path,
          query: { page: pagination.value.page },
        });
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.id = store.state.org.unidadeData.id;
        getData();
      }
    );

    const handleRequest = async () => {
      getData(pagination.value.page, pagination.value.rowsPerPage);
    };
    return {
      disable,
      pagination,
      getData,
      rows,
      unidade,
      handleRequest,
      columns,
      filtrar,
      reativar,
      confirmarReativacao,
      reativarConfirmado,
      scrollUp,
      table,
      dialogConfirmacao,
      reativarDialog,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 0;
}
.my-sticky-dynamic {
  max-height: 600px;
}
thead tr th {
  white-space: pre-wrap !important;
}
tbody tr td {
  white-space: pre-wrap;
}
</style>
